import { displayError, getApiUrl, getCurrentLanguageId, addEventListenerIfNotExists } from "./common";
import HttpClient from "./http-client";
import LoadingIndication from "./loading-indication";


export default class RedsysPayment {
    private readonly baseElement: HTMLFormElement;
    private readonly orderGuid: string;
    private readonly referenceId: string;
    private static componentName = 'RedSysPayment';
    
    constructor() {
        this.baseElement = document.querySelector(`[data-component="${RedsysPayment.componentName}"]`);
        this.orderGuid = this.baseElement.dataset.orderGuid;
        this.referenceId = this.baseElement.dataset.referenceId;
        addEventListenerIfNotExists(this.baseElement, 'submit', async (evt) => await this.processForm(evt));
    }

    private async processForm(event: Event): Promise<void> {
        event.preventDefault();
        this.startLoading();
        await this.createPayment();

        const form = event.target as HTMLFormElement;
        form.submit();
    }

    private async createPayment() {
        const url = `${getApiUrl()}/RedSys/create-payment`;
        const response = await new HttpClient().fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                orderGuid: this.orderGuid,
                returnUrl: window.location.href,
                referenceId : this.referenceId
            }),
            headers: {
                'Content-Type': 'application/json',
                'Current-Language-Id': getCurrentLanguageId()
            }
        }, (e) => {
            this.stopLoading();
            displayError("Payment creation failed. " + e);
            return null;
        });

        if (!response.ok) {
            this.stopLoading();
            displayError("Payment creation failed.");
            return null;
        }
    }

    private startLoading() {
        LoadingIndication.show(this.baseElement);
    }

    private stopLoading() {
        LoadingIndication.hide(this.baseElement);
    }
}
